module.exports = "<span class=\"oi oi-arrow-top\"></span>\n<span class=\"oi oi-audio-spectrum\"></span>\n<span class=\"oi oi-warning\"></span>\n"